export default {
  jump1: '后自动跳转',
  LoginPassword: '密码登录',
  quickLogin: '快捷登录',
  smsLogin: '短信验证码登录',
  usernameLogin: '账号密码登录',
  loginOrRegister: '登录/注册',
  forgetPassword: '忘记密码？',
  login: '登录',
  or: '或者',
  signTips: '没有账户？',
  signTips1: '立即注册',
  passwordTips: '忘记密码？',
  backLogin: '返回密码登录',
  resetPassword: '重置密码',
  newPassword: '新密码',
  confirmNewPassword: '确认新密码',
  setPassword: '新密码设置成功',
  loginImmediately: '立即登录',
  gender: '请选择性别',
  nextStep: '下一步',
  existingAccounts: '已有账号？',
  noAccount: '没有账号？',
  immediatelyRegister: '立即注册',
  backStep: '返回上一步',
  register: '注册',
  tips1: '恭喜您注册成功',
  tips2: '扫描二维码，关注学校微信公众号，及时查看动态变化',
  tips3: '扫描二维码，绑定微信，快捷登录',
  tips4: '请扫码进入报名',
  tips5: '微信端报名入口',
  phone: '招生办电话',
  address: '地址',
  admissionsOffice: '招生办公室',
  switchboard: '总机',
  schoolService: '学校公众号',
  contactUs: '联系我们',
  language: '语言选择',
  postalCode: '邮政编码',
  step1: '填写用户信息',
  step2: '创建账号和密码',
  step3: '关注公众号',
  back: '返回',
  sex1: '男',
  sex2: '女',
  wechatOffical: '微信公众号',
  setNew: '新密码设置成功'
}



// WEBPACK FOOTER //
// ./src/views/parentLogin/lang/zh.js